import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/do'

import he from 'he'
import parser from 'fast-xml-parser'

import { ICaptionsInfo, ICaption, ICaptionTracks, ICaptionTranslationLanguages } from '../models'
import { YouTubeCaptionApi } from '../apis'
import { AppState } from '../reducers'
import { InitCaption, SelectVideo, LoadCaption } from '../actions/youtube-captions'
import { TranslateService } from '@ngx-translate/core'

@Injectable()
export class YouTubeCaptionService {
  constructor(
    private api: YouTubeCaptionApi,
    private store: Store<AppState>,
    private translate: TranslateService,
  ) {
    // store.select(state => state.youtubeCaption.info)
    //   .distinctUntilChanged()
    //   .subscribe(info => {
    //     this.trackList = info.playerCaptionsTracklistRenderer.captionTracks
    //     this.languageList = info.playerCaptionsTracklistRenderer.translationLanguages
    //   })
  }
  private trackList: ICaptionTracks[]

  load(videoId: string): Observable<ICaptionsInfo> {
    return this.api.getCaptionsInfo(videoId)
      .map(text => this.parseCaptionsInfo(text))
      .do(info => this.trackList = info.playerCaptionsTracklistRenderer.captionTracks)
      .map(info => {
        info.playerCaptionsTracklistRenderer.translationLanguages = info.playerCaptionsTracklistRenderer.translationLanguages.sort((a, _) => a.languageCode === this.translate.currentLang ? -1 : a.languageCode ==='en' ? -1 : 0)
        return info
      })
      .do(info => this.store.dispatch(new SelectVideo(info)))
  }

  private _getCaption(url: string): Observable<ICaption[]> {
    const options: Partial<parser.X2jOptions> = {
      attributeNamePrefix: '',
      attrNodeName: 'attr', //default is 'false'
      textNodeName : 'content',
      ignoreAttributes : false,
      parseNodeValue : false,
      parseAttributeValue : true,
      tagValueProcessor: a => he.decode(he.decode(a)) //default is a=>a
    }
    return this.api.getCaptions(url)
      .map(res => {
        let obj = parser.parse(res, options)
        return obj ? obj.transcript? obj.transcript.text as ICaption[] : null : null
      })
      .do(cap => this.store.dispatch(new LoadCaption(cap)))
  }

  getTranslatedCaption(base: ICaptionTracks, languageCode: string): Observable<ICaption[]> {
    if(!base.isTranslatable) return Observable.throw(new Error('翻訳元の字幕が翻訳操作に対応していません'))
    return this._getCaption(base.baseUrl + '&tlang=' + languageCode)
  }

  getCaption(languageCode: string): Observable<ICaption[]> {
    //まずtrackListに手動追加されたものがないか探す
    let track = this.getAuthenticTrackByLanguageCode(languageCode)
    if (track) {
      console.log(`using ${track.vssId}`)
      return this._getCaption(track.baseUrl)
    }

    console.log('fallback into auto-generated')

    //自動生成がないか探す
    track = this.getTrackByVssCode(`a.${languageCode}`)
    if (track) {
      console.log(`using ${track.vssId}`)
      return this._getCaption(track.baseUrl)
    }

    console.log('fallback into translated')
    //ないので翻訳に適切な元字幕を探す
    //英語
    try{
      track = this.getAuthenticTrackByLanguageCode('en')
      if (track) {
        console.log(`using ${track.vssId}`)
        return this.getTranslatedCaption(track, languageCode)
      }
    } catch {
      console.log('Authentic English captions is not available or translatable.')
    }

    //英語以外
    try{
      track = this.getTranslatableAuthenticTrack()
      if (track) {
        console.log(`using ${track.vssId}`)
        return this.getTranslatedCaption(track, languageCode)
      }
    } catch {
      console.log('Any authentic captions is not available or translatable.')
    }

    try {
      track = this.getAutoGeneratedTrack()
      if (track) {
        console.log(`using ${track.vssId}`)
        return this.getTranslatedCaption(track, languageCode)
      }
    } catch {
      return Observable.throw(new Error('字幕の取得に失敗しました'))
    }
  }

  private getAuthenticTrackByLanguageCode = (languageCode: string) => this.getTrackByVssCode(`.${languageCode}`)

  private getTrackByVssCode = (vssCode: string) => this.trackList.find(track => track.vssId === vssCode)

  private getAutoGeneratedTrack = () => this.trackList.find(track => track.kind === 'asr')

  private getTranslatableAuthenticTrack = () => this.trackList.find(track => track.kind ? track.kind !== 'asr' && track.isTranslatable : track.isTranslatable)

  private parseCaptionsInfo(body: string): ICaptionsInfo{
    let target = body.split('"captions":')[1]
    if(!target) throw new Error('キャプション情報を取得できませんでした')

    // walk
    let firstBracket = () => {
      for (let i = 0; i < target.length; i++) {
        if (target[i] === '{') return i
      }
      throw new Error()
    }
    let lastBracket = () => {
      let i, bracketCount
      for (i = firstBracket() + 1, bracketCount = 1; i < target.length && bracketCount > 0; i++) {
        if (target[i] === '{') bracketCount++
        if (target[i] === '}') bracketCount--
      }
      return i
    }
    return JSON.parse(target.substring(0,lastBracket()))
  }
}



// WEBPACK FOOTER //
// ./src/services/youtube-caption.ts